/* oxlint-disable jsx-a11y/anchor-has-content */

'use client';

import { ComponentProps } from 'react';

import { getFlipsterUrl } from '@flipster/features/src/shared/urls';
import { useDepositModal } from '@flipster/features/src/shared/wallet-modal/deposit';
import { useCopy } from '@flipster/features/src/shared/webview/clipboard';
import { zendesk } from '@flipster/features/src/shared/zendesk/url';
import { SparkRewardPage } from '@flipster/features/src/spark/reward';
import { NoSSR } from '@flipster/react/misc/lifecycle/NoSSR';
import { UsdtCurrency } from '@flipster/utils/constants/currency';
import segment from '@flipster/utils/segment';
import { SparkEvent } from '@flipster/utils/segment/events/spark';

export const DepositCta: NonNullable<ComponentProps<typeof SparkRewardPage>['summary']>['DepositCta'] = (props) => {
  const openDepositModal = useDepositModal();
  const onClickDepositToUpgradeMultiplier = () => {
    openDepositModal({ defaultValues: { currency: UsdtCurrency } });
    segment.track(SparkEvent.EarnSparkPageDepositClick);
  };
  return <button {...props} type='button' onClick={onClickDepositToUpgradeMultiplier} />;
};

export const TradeCta = ((props) => {
  const onClickTradeNow = () => {
    segment.track(SparkEvent.EarnSparkPageTradeClick);
  };
  // next.js 의 <Link> 로 페이지 이동 시 app link 와 universal link 가 설정되어 있더라도 앱이 열리지 않는 문제가 있어 a tag 를 그대로 사용함
  return <a {...props} href='/trade/perpetual' onClick={onClickTradeNow} />;
}) satisfies ComponentProps<typeof SparkRewardPage>['trade']['TradeCta'];

export const MultiplierCta = (({ onClick, ...props }) => {
  const onClickMultiplier = () => {
    segment.track(SparkEvent.EarnSparkPageMultiplierInfoClick);
    onClick?.();
  };
  return <button {...props} type='button' onClick={onClickMultiplier} />;
}) satisfies NonNullable<ComponentProps<typeof SparkRewardPage>['summary']>['MultiplierCta'];

export const TermsAndConditionsCta = ((props) => {
  return (
    <NoSSR>
      <a {...props} href={zendesk.getUrl('SparkRewardProgram')} />
    </NoSSR>
  );
}) satisfies NonNullable<ComponentProps<typeof SparkRewardPage>['rules']>['TermsAndConditionsCta'];

export const ShareCta = ((props) => {
  const copy = useCopy('Link copied');
  const url = `${getFlipsterUrl()}/spark/reward?share`;

  const onClickShare = () => {
    // TODO: add logger
    if (navigator.share) {
      navigator.share({ title: document.title, url });
    } else {
      copy(url);
    }
  };

  return <button {...props} type='button' onClick={onClickShare} />;
}) satisfies NonNullable<ComponentProps<typeof SparkRewardPage>['share']>['ShareCta'];
